import { render, staticRenderFns } from "./ProductionKanban.vue?vue&type=template&id=30133e48&"
import script from "./ProductionKanban.vue?vue&type=script&lang=js&"
export * from "./ProductionKanban.vue?vue&type=script&lang=js&"
import style0 from "./ProductionKanban.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports